interface ConfigErrorProps {
  missingVars: string[]
}

export function ConfigError({ missingVars }: ConfigErrorProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-lg w-full bg-white rounded-xl shadow-lg p-8">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-8 h-8 text-yellow-600"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"
            />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2 text-center">Configuration Required</h1>
        <p className="text-gray-600 mb-6 text-center">
          The application is missing required environment variables. Please configure them in your deployment settings.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <h2 className="text-sm font-semibold text-gray-700 mb-3">Missing Variables:</h2>
          <ul className="space-y-2">
            {missingVars.map((varName) => (
              <li key={varName} className="flex items-center gap-2 text-sm">
                <span className="w-2 h-2 bg-red-500 rounded-full"></span>
                <code className="font-mono text-red-700 bg-red-50 px-2 py-0.5 rounded">
                  {varName}
                </code>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-blue-50 rounded-lg p-4">
          <h2 className="text-sm font-semibold text-blue-800 mb-2">How to fix:</h2>
          <ol className="text-sm text-blue-700 space-y-1 list-decimal list-inside">
            <li>Go to your Vercel project dashboard</li>
            <li>Navigate to Settings → Environment Variables</li>
            <li>Add the missing variables listed above</li>
            <li>Redeploy the application</li>
          </ol>
        </div>
      </div>
    </div>
  )
}

export default ConfigError
